<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Resend document(s)</h4>
</div>
<div class="form-group modal-body">

    <label>{{selectedRows}} Selected Row(s)</label>
    <br>

    <app-toggle-button #toggleButton [ngModel]="selectedButtons()" [buttons]="buttons" (valueChange)="onUseCustomChange($event)"></app-toggle-button>

    <!--RESEND BY INTERCHANGE-->
    @if(selectedButtons().includes(this.INTERCHANGE_KEY)){
        <label class="resend-interchange-info">Resending at the interchange level may lead to multiple documents being sent when the ingoing interchange contains more than one document or when multiple matching distributions are configured.</label>

        @if(interchangesWithOneDocument() > 0 && !this.onlyInterchangesWithNoDocumentsAndMissingMessageIn()) {
            <label>{{interchangesWithOneDocument()}} Selection(s) will be resent on interchange level.</label>
        }
        @else if(interchangesWithOneDocument() > 0 && warningTexts().length > 0) {
            <label>{{interchangesWithOneDocument()}} Selection(s) will be resent on interchange level.</label>
        }

        @if (warningTexts().length > 0)
        {
            <div class="bs-callout bs-callout-warning pull-left fit-in-form-group">
                @for (text of warningTexts(); track $index) {
                    <label>{{text}}</label>
                }
            </div>
        }
        @else if(this.onlyInterchangesWithNoDocumentsAndMissingMessageIn() && informationTexts().length > 0){
            <div class="bs-callout bs-callout-primary pull-left fit-in-form-group">
                @for (text of informationTexts(); track $index) {
                    <label>{{text}}</label>
                }
            </div>
        }
    }
    @else { <!--RESEND BY MESSAGE-->
        @if(documentCount() > 0) {
            <label>{{documentCount()}} Selection(s) will be resent on message level.</label>
        }
        @if((interchangesWithNoDocumens().size > 0 || interchangesMissingMessageIn().size > 0) && informationTexts().length === 0){
            @if(documentCount() > 0){
                <br>
            }
            <label>{{totalInterchangeSelections()}} Selection(s) will be resent on interchange level</label>
        }

        @if(informationTexts().length > 0){
            <div class="bs-callout bs-callout-primary pull-left fit-in-form-group">
                @for (text of informationTexts(); track $index) {
                    <label>{{text}}</label>
                }
            </div>
        }
    }

    <br>
    <br>
    <div class="form-group">
        <label>Comment (optional)</label>
        <textarea class="form-control noresize" [(ngModel)]="resendResult().comment" [bizFocus]="true" [bizFocusTriggerChange]="focusTriggerChange()" maxlength="500"></textarea>
    </div>

    <div *bizPermissionRequired="'Tracking_Action_ResendGenerateNewTransmissionId'">
        <label
            title="If checked a new transmission id, for the outgoing interchange, will be generated which might prevent the receiver from detecting duplicates">
            <input type="checkbox" [(ngModel)]="resendResult().resendGenerateNewTransmissionId" />&nbsp;Generate new
            transmission id
        </label>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="ok()">Resend</button>
    <button type="button" class="btn btn-link" (click)="close()">Cancel</button>
</div>
